import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';
import { i18n } from 'utils/i18n';

export const prepayFlopCurrentSession = (isPayLater) => (dispatch) =>
  dispatch(
    gmiRequest({
      action: actions.request({
        data: { isPayLater },
        service: services.gma.reservations.prepayFlop,
      }),
      loadingOverlay: true,
      loadingMessage: isPayLater ? i18n('switched_to_prepay') : i18n('switched_to_pay_later'),
    })
  );
